import { NavLink, Outlet } from "react-router";
import { useTranslation } from "react-i18next";
import { cx } from "@/utils/cx";

const SETTINGS_BASE = "/admin/settings";

const TAB_LINKS = [
  { to: `${SETTINGS_BASE}/menu-config`, label: "Menu Configuration" },
  { to: `${SETTINGS_BASE}/platform-settings`, label: "Platform Settings" },
  {
    to: `${SETTINGS_BASE}/outbound-email-templates`,
    label: "Outbound Emails Templates",
  },
  {
    to: `${SETTINGS_BASE}/tracking-management`,
    label: "Tracking Management",
  },
] as const;

export const SettingsPage = () => {
  const { t } = useTranslation(["pages:settings-admin", "common"]);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold text-primary">{t("title")}</h1>
          <p className="text-tertiary mt-1">{t("subtitle")}</p>
        </div>
      </div>

      <nav
        className="flex gap-1 border-b border-secondary"
        aria-label="Settings sections"
      >
        {TAB_LINKS.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            end={!to.includes("outbound-email-templates")}
            className={({ isActive }) =>
              cx(
                "rounded-t-lg px-4 py-2.5 text-sm font-semibold outline-focus-ring -mb-px border-b-2 border-transparent",
                isActive
                  ? "border-fg-brand-primary_alt text-brand-secondary"
                  : "text-tertiary hover:text-primary hover:border-secondary"
              )
            }
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
};
